module.exports = __webpack_public_path__ + "media/images/warsaw_coffee_tour_green-e81bebee9671ff35fedf1992d47c4b8c.svg";